import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  GlobalMessagingService,
  SessionMessagingService,
} from './messaging.service'
import { WebSocketsService } from './services/web-sockets/web-sockets.service'

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule],
  providers: [
    {
      provide: GlobalMessagingService,
      useClass: WebSocketsService,
    },
    {
      provide: SessionMessagingService,
      useClass: WebSocketsService,
    },
  ],
})
export class MessagingModule {}
